/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Pricing_Feature_Pro_CreditsInputs */

const en_landing_pricing_feature_pro_credits = /** @type {(inputs: Landing_Pricing_Feature_Pro_CreditsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`100 AI autofill runs included`)
};

const zh_landing_pricing_feature_pro_credits = /** @type {(inputs: Landing_Pricing_Feature_Pro_CreditsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`含 100 次 AI 自动填充`)
};

/**
* | output |
* | --- |
* | "100 AI autofill runs included" |
*
* @param {Landing_Pricing_Feature_Pro_CreditsInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const landing_pricing_feature_pro_credits = /** @type {((inputs?: Landing_Pricing_Feature_Pro_CreditsInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Pricing_Feature_Pro_CreditsInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_landing_pricing_feature_pro_credits(inputs)
	return zh_landing_pricing_feature_pro_credits(inputs)
});
export { landing_pricing_feature_pro_credits as "landing.pricing.feature_pro_credits" }